import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { Arrow } from '@components/Arrow';

const contentSizeCss = css`
  max-height: 18.75rem !important;
  max-width: calc(100vw - 40px) !important;
  margin: auto;
`;

export const ZoomWrapper = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;

export const ImageSliderWrapper = styled.div<{ newPdDesign: boolean }>`
  ${({ newPdDesign }) =>
    newPdDesign
      ? css`
          position: relative;
          left: -0.9375rem;
          width: 100vw;
          background-color: ${theme.color.background.disabled};
          height: 21.875rem;
          margin-bottom: 1.25rem;
          aspect-ratio: 1 / 1;
          @media (min-width: ${breakpoints.lg}) {
            display: none;
          }
          @media (min-width: ${breakpoints.md}) {
            height: auto;
          }
        `
      : css`
          .use-spring-carousel-track-wrapper {
            align-items: start;
          }
          @media (min-width: ${breakpoints.md}) {
            display: none;
          }
        `}

  overflow: hidden;
`;

export const PlayerWrapper = styled.div<{ newPdDesign: boolean }>`
  ${({ newPdDesign }) =>
    newPdDesign
      ? css`
          display: flex;
          align-items: center;
          width: 100%;

          height: 100%;
          iframe {
            ${contentSizeCss}
          }
        `
      : css`
          ${contentSizeCss}
          iframe {
            ${contentSizeCss}
          }
        `}
`;

export const ImgWrapper = styled.div<{
  newPdDesign: boolean;
  isSquare?: boolean;
}>`
  height: 100%;
  position: relative;
  overflow: hidden;

  margin: auto;

  > div {
    min-width: 5rem; // notino placeholder logo is not visible without this
  }

  ${({ newPdDesign, isSquare }) =>
    newPdDesign
      ? css`
          background-color: ${theme.color.background.disabled};
          max-width: 100vw;
          margin: auto;

          ${isSquare
            ? css`
                > div:first-child {
                  height: 100%;
                }
                img {
                  width: 100%;
                }
              `
            : css`
                padding: 0 2.25rem;
                height: 100%;
                img {
                  width: auto;
                  max-width: 100% !important;
                  height: auto;
                  max-height: min(21.875rem, 80%) !important;
                }
                > div:first-child {
                  // use first-child so we don't target modiface overlay
                  max-height: 100%;
                }
              `}

          @media (min-width: ${breakpoints.md}) {
            height: 100%;
          }
          img {
            mix-blend-mode: multiply;
            min-height: auto;

            max-height: ${isSquare ? 'none' : '100%'};
          }
        `
      : css`
          height: 18.75rem;
          ${contentSizeCss};

          padding-left: 1.25rem;
          padding-right: 1.25rem;
          img {
            width: auto;
            max-width: 100% !important;
            height: auto;
            max-height: 100% !important;
            @media (min-width: ${breakpoints.md}) {
              height: 100%;
              width: auto;
              max-width: unset;
            }
          }
        `}
`;

export const StyledArrow = styled(Arrow)<{ newPdDesign: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;

  ${({ direction }) =>
    direction === 'left'
      ? css`
          left: 0;
        `
      : css`
          right: 0;
        `}

  ${({ newPdDesign }) =>
    newPdDesign &&
    css`
      background-color: ${theme.color.common.transparent};
      height: 3rem;
      width: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;
